export const socialsData = {
    github: 'https://github.com/sreerag-rajan',
    facebook: '',
    linkedIn: 'https://www.linkedin.com/in/sreerag-rajan-55383a222',
    instagram: '',
    codepen: '',
    twitter: '',
    reddit: '',
    blogger: '',
    medium: 'https://medium.com/@sreerag.rajan5',
    stackOverflow: '',
    gitlab: '',
    youtube: ''
}